import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CallingScriptModal = ({
  showCallingScript,
  handleClose,
  customer_name,
  product_name,
  customer_mobile_number,
  notice_date,
  email_id,
  loan_account_no,
  pos,
  pre_approved_settlement_amount,
  collection_manager_name,
  collection_manager_mobile_number,
  client_name,
}) => {
  const [language, setLanguage] = useState('english');

  // Helper to format date like "4th December 2025"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1:  return 'st';
        case 2:  return 'nd';
        case 3:  return 'rd';
        default: return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  const hasSettlementAmount = Number(pre_approved_settlement_amount) > 0;

  return (
    <Modal show={showCallingScript} onHide={handleClose} centered dialogClassName="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notice Information</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {language === 'english' ? (
          <div>
            <p className='mt-3'>
              Hi, I am calling from K S Legal. Am I speaking with <strong>{customer_name}</strong>?
            </p>

            <p>
              You have defaulted on the <strong>Credit Card</strong> account ending <strong>{loan_account_no}</strong>, issued by <strong>{client_name}</strong>. Is that correct?
            </p>

            <p>
              We have been assigned this case by <strong>{client_name}</strong> to initiate legal proceedings. A legal notice has already been sent to your registered email ID on <strong>{formatDate(notice_date)}</strong>.
            </p>

            <p>
              Due to continuous non-payment, the Bank has instructed us to proceed with legal action, which may include civil proceedings, criminal proceedings, or a police complaint, as per law.
            </p>

            <p>
              However, before proceeding legally, the Bank is offering you a One Time Settlement. Your total outstanding is <strong>₹{pos}</strong>
              {hasSettlementAmount ? (
                <span>, which can be settled for <strong>₹{pre_approved_settlement_amount}</strong></span>
              ) : (
                <span></span>
              )}, subject to immediate confirmation aur payment.
            </p>

            <p>
              If you are agreeable to this One Time Settlement, please confirm during this call. If not, we will proceed with legal action as instructed by the Bank.
            </p>
          </div>
        ) : (
          <div>
            <p className='mt-3'>
              Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?
            </p>

            <p>
              Aapka <strong>{client_name}</strong> ka <strong>Credit Card</strong> account <strong>{loan_account_no}</strong> pe end hota hai aur system ke according aapka payment default mein hai — kya ye sahi hai?
            </p>

            <p>
              Ye case hume legal proceedings start karne ke liye assign kiya gaya hai. <strong>{formatDate(notice_date)}</strong> ko aapke registered email ID par legal notice bheja ja chuka hai.
            </p>

            <p>
              Legal action se pehle, Bank aapko One Time Settlement ka final option de raha hai. Aapka total outstanding <strong>₹{pos}</strong> hai
              {hasSettlementAmount ? (
                <span>, jo <strong>₹{pre_approved_settlement_amount}</strong> mein settle ho sakta hai</span>
              ) : (
                <span></span>
              )}, subject to immediate confirmation aur payment.
            </p>

            <p>
              Agar aap agree karte hain, isi call par confirm karein. Agar nahi, to Bank ke instructions ke according legal action proceed kiya jayega.
            </p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between w-100">
        <Button
          variant="primary"
          size="md"
          onClick={() => setLanguage(language === 'english' ? 'hindi' : 'english')}
        >
          {language === 'english' ? 'Switch to Hindi' : 'Switch to English'}
        </Button>

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default CallingScriptModal;